// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2Dh9q","label":"Labeled_label__3exc5","divider":"Labeled_divider__26rtt"};